import React from "react";
import classNames from "classnames";
import { getParkWebBannerText, isBannerEnabled } from "../../banner/Banner";
import TopBanner from "../../banner/TopBanner";
import { FooterParkWeb } from "../footer/FooterParkWeb";
import GetDomainButton from "../commonComponents/GetDomainButton";
import { TrustArcConsentDialog } from "../../consentManager/TrustArcComponents";
import { useConsentStatus } from "../../consentManager/useConsentStatus";
import { useLanderConfig } from "../../commons/ConfigContext";
import { AdContent } from "../AdContent";
import { LanderConfig } from "../../types/LanderConfig";
import { useGdAdsEuConsentExperiment } from "../../experimentation/useGdAdsEuConsentExperiment";
import { useGdAdsExperiment } from "../../experimentation/useGdAds3WayExperiment";
import { GDAds } from "../../inHouseAds/GDAds";
import classes from "./ParkWebLayout.module.scss";

type ParkWebLayoutProps = {
  page: string;
  content: { [key: string]: string };
};

type DomainInfoProps = {
  landerConfig: LanderConfig;
  content: { [key: string]: string };
};

export function DomainInfo({ landerConfig, content }: DomainInfoProps) {
  const text = getParkWebBannerText(landerConfig, content);
  if (!text) return null;
  return <div className={ classes.domainInfo }>{text}</div>;
}

function Domain({ domain }: { domain: string }) {
  if (!domain) return null;
  return <div className={ classes.domain }>{domain}</div>;
}

export default function ParkWebLayout({ page, content }: ParkWebLayoutProps) {
  const { landerConfig } = useLanderConfig();
  const consentStatus = useConsentStatus();
  const { inTreatmentCohort: gdAdsEuConsentExperiment } =
    useGdAdsEuConsentExperiment();
  const { inTreatmentCohort: parkingPw4541GdAds } = useGdAdsExperiment();
  const domain = landerConfig.domain?.rootDomainDisplayText;

  let domainContent = null;
  if (isBannerEnabled(landerConfig)) {
    domainContent = (
      <div data-testid="parkwebLayout" className={ classes.contentLayout }>
        <div className={ classes.domainStatusText }>
          <Domain domain={ domain } />
          <DomainInfo landerConfig={ landerConfig } content={ content } />
        </div>
        <div className={ classes.getDomain }>
          <GetDomainButton landerConfig={ landerConfig } />
        </div>
      </div>
    );
  }

  let adContent = null;
  if (gdAdsEuConsentExperiment || parkingPw4541GdAds) {
    adContent = <GDAds landerConfig={ landerConfig } />;
  } else if (consentStatus.showConsentDialog) {
    adContent = <TrustArcConsentDialog />;
  } else {
    adContent = (
      <div className={ classes.adContent }>
        <AdContent page={ page } />
      </div>
    );
  }

  return (
    <div className={ classes.parkWebLander }>
      <TopBanner flexColumnOnMobile={ true } />
      <div className={ classes.contentMain }>
        <div className={ classes.domainCard }>{domainContent}</div>
      </div>
      <div
        className={ classNames(classes.contentSuggestions, {
          [classes.gdAds]: gdAdsEuConsentExperiment || parkingPw4541GdAds,
        }) }
      >
        {adContent}
      </div>
      <FooterParkWeb
        copyrightTextId="parkwebcopyrightText"
        parkwebDisclaimerText="parkwebDisclaimerText"
      />
    </div>
  );
}
